import React, { Component } from "react";
import StepperEvent from "../../../../../Components/StepperEvent";
import Table from "../../../../../Components/Table";
import { Card, CardBody, Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import TablesEvent from "./tablesEvent";

const Icons = {
  AEREO: "https://fsposeidon.blob.core.windows.net/roldan/icon_avion.png",
  MARITIMO: "https://fsposeidon.blob.core.windows.net/roldan/icon_barco.png",
  CARRETERO: "https://fsposeidon.blob.core.windows.net/roldan/icon_camion.png",
};

class Events extends Component {
  state = {
    allTables: [],
    allSteps: [],
    data: [],
    columns: [
      {
        label: "Descripción del Evento",
        key: "EventDescription",
        idTh: "firstTh",
        idTd: "firstTd",
      },
      {
        label: "Fecha del Evento",
        key: "EventDate",
        idTh: "firstTh",
        idTd: "firstTd",
      },
      {
        label: "Categoría de Responsable",
        key: "CategoryResponsable",
        idTh: "firstTh",
        idTd: "firstTd",
      },
      { label: "Origen", key: "Origin", idTh: "firstTh", idTd: "firstTd" },
      {
        label: "Fecha de Creación",
        key: "CreateDate",
        idTh: "firstTh",
        idTd: "firstTd",
      },
    ],
    DOAduanaExpo: "",
    DocTransporte: "",
    HBL_HAWB: "",
    id: this.props.match.params.id,
    steps: [
      {
        label: "Instrucción Cliente AA (Reserva)",
        value: "",
        id: 2,
        completed: false,
        order: 1,
        middleStep: "",
      },
      {
        label: "Autorización de Embarque",
        value: "",
        id: 8,
        completed: false,
        order: 2,
        idStep: "",
        middleStep: "",
      },
      {
        label: "Cierre Físico",
        value: "",
        id: 13,
        completed: false,
        order: 3,
        middle: false,
        idStep: "",
        middleStep: "",
      },
      {
        label: "Manifiesto de Carga",
        value: "",
        id: 16,
        completed: false,
        order: 4,
        idStep: "step4",
        middleStep: "",
      },
      {
        label: "Facturación y Entrega de Documentos",
        value: "",
        id: 18,
        completed: false,
        order: 5,
        idStep: "step5",
        middleStep: "",
      },
    ],
  };

  componentDidMount = () => {
    this.setState(
      {
        allSteps: this.props.allSteps,
        steps: this.props.steps,
        HBL_HAWB: this.props.HBL_HAWB,
        DocTransporte: this.props.DocTransporte,
        DOAduanaExpo: this.props.DOAduanaExpo,
        Estatus: this.props.Estatus,
        cliente: this.props.cliente,
        NIT: this.props.NIT,
        Grupo: this.props.Grupo,
        Info: this.props.Info,
      },
      () => {
        this.createTables();
      },
    );
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        allSteps: nextProps.allSteps,
        steps: this.props.steps,
        HBL_HAWB: this.props.HBL_HAWB,
        DocTransporte: this.props.DocTransporte,
        DOAduanaExpo: this.props.DOAduanaExpo,
        Estatus: nextProps.Estatus,
        cliente: nextProps.cliente,
        NIT: nextProps.NIT,
        Grupo: nextProps.Grupo,
        Info: nextProps.Info,
      },
      () => {
        this.createTables();
      },
    );
  };

  createTables = () => {
    var allTables = [];
    this.state.allSteps.map((e) => {
      var findTable = false;
      allTables.map((f) => {
        if (f.eventType === e.EventType) {
          f.data.push(e);
          findTable = true;
        }
        return f;
      });
      if (!findTable) {
        var obj = {
          eventType: e.EventType,
          data: [e],
        };
        allTables.push(obj);
      }
      return e;
    });
    this.setState({ allTables: allTables });
  };

  render() {
    let { cliente, NIT, Grupo, Info } = this.state;
    return (
      <>
        <Card className="myCard">
          <CardBody>
            <Row>
              <div className="col-xs-2 col-md-1 col-lg-1 d-flex justify-content-center d-flex align-items-center">
                <i
                  style={{ color: "#582c83" }}
                  className="fa-3x fas fa-arrow-alt-circle-left"
                ></i>
              </div>
              <div className="col-xs-10 col-md-6 col-lg-6">
                <p className="sizeTextComents">
                  {cliente} ({NIT}) / {Grupo}
                </p>
                <p className="sizeTextComents" style={{ color: "#0099ff" }}>
                  {this.state.DOAduanaExpo}
                </p>
                <p className="sizeTextComents"> {this.state.DocTransporte}</p>
              </div>
              <div className="col-12 mt-1">{this.state.Estatus}</div>
            </Row>
            <div className="col-12 flex justify-content-center d-flex align-items-center">
              <img
                alt=""
                src={Icons[Info && Info.ModoTransporte] || ""}
                width="50"
              ></img>
              <StepperEvent steps={this.state.steps} />
            </div>
          </CardBody>
        </Card>
        <Card className="myCard">
          <CardBody>
            {this.state.allTables.length > 0 ? (
              <TablesEvent
                columns={this.state.columns}
                allTables={this.state.allTables}
              />
            ) : (
              <Table
                columns={this.state.columns}
                data={this.state.data}
                options={{
                  large: false,
                  downloads: {
                    pdf: false,
                    xlsx: false,
                  },
                }}
              />
            )}
          </CardBody>
        </Card>
      </>
    );
  }
}

export default withRouter(Events);
